module.exports = __webpack_public_path__ + "img/aria_azul.4bdcbff3.svg";